
import WarehouseIcon from '@mui/icons-material/Warehouse';

export const warehouseFinancialInvoicesConfig = (conceptProductCount) => {
    return {
        all:  {
            title: 'all_invoices',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        conceptInvoiceProducts:  {
            title: 'invoicelines_to_accept',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...((conceptProductCount && conceptProductCount.conceptCount > 0) && {count: conceptProductCount.conceptCount})
        },
        ordersWithoutCosts:  {
            title: 'orders_without_costs',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...((conceptProductCount && conceptProductCount.orderCount > 0) && {count: conceptProductCount.orderCount})
        },
        returnsWithoutCosts:  {
            title: 'returns_without_costs',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...((conceptProductCount && conceptProductCount.returnCount > 0) && {count: conceptProductCount.returnCount})
        },
        shipmentsWithoutCosts:  {
            title: 'shipments_without_costs',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...((conceptProductCount && conceptProductCount.shipmentCount > 0) && {count: conceptProductCount.shipmentCount})
        },
        mutations:  {
            title: 'mutations',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        shippingCostOverview:  {
            title: 'shipping_cost_overview',
            icon: <WarehouseIcon/>,
            // The period is picked through the shared filter bar in the tab header; the totals
            // cards read that same date range back from the grid filter state.
            isSingleDataGrid: true,
        },
    }
};
